// Pages that use the feed pack also use stuff like MentionableComments
// So, we will import the main 'strava_with_framework' that imports
// and registers that component.
import './strava_with_framework';

import ReactComponentMounter from '../utils/react-component-mounter';

// Feed specific components:
import Feed from '../apps/feed/Feed';
// 4/21/21 - MaharajAchievementCelebration is being used app/views/feed3p0/achievement_celebration/_base.haml
import MaharajAchievementCelebration from '../apps/feed/components/shared/MaharajAchievementCelebration';
import Activity from '../apps/feed/components/Activity';
import Post from '../apps/feed/components/Post';
import ChallengeJoin from '../apps/feed/components/ChallengeJoin';
import ClubJoin from '../apps/feed/components/ClubJoin';
import RunningRaceJoined from '../apps/feed/components/RunningRaceJoined';
import FancyPromo from '../apps/feed/components/FancyPromo';
import SimplePromo from '../apps/feed/components/SimplePromo';
import GroupActivity from '../apps/feed/components/GroupActivity';
import PerformanceGoalCreated from '../apps/feed/components/PerformanceGoalCreated';

// Modules from <packs />
import EmailVerificationCTA from '../components/EmailVerificationCTA';
import FeedEntryAgeGate from '../apps/challenges/FeedEntryAgeGate';
import NotificationEmailVerificationCTA from '../components/EmailVerificationCTA/placements/NotificationEmailVerificationCTA';

ReactComponentMounter.register({
  Feed,
  MaharajAchievementCelebration,
  Activity,
  Post,
  ChallengeJoin,
  ClubJoin,
  RunningRaceJoined,
  FancyPromo,
  SimplePromo,
  GroupActivity,
  PerformanceGoalCreated,
  EmailVerificationCTA,
  FeedEntryAgeGate,
  NotificationEmailVerificationCTA
});
